import { useMutation } from "react-query";
import { completeTasks } from "../taskState";

export const useChangeTasksStatuses = () => {
    return useMutation(({ tasks, sourcePage, action }) => {
        return completeTasks(tasks, sourcePage, action);
    });
};
